import React, { useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import "./CreateVoucherAndCouponsInputs.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datepickericon from "../../assets/date-picker.svg";
import { Image } from "react-bootstrap";
import ImageUploadCrop from "../ImageUpload/ImageUploadCrop";

const CreateCouponInputs = (props) => {
  const [startDate, setStartDate] = useState(props.initialStartDate || null);
  const [endDate, setEndDate] = useState(props.initialEndDate || null);
  const [availableDate, setAvailableDate] = useState(
    props.initialAvailableDate || null,
  );
  const [quantity, setQuantity] = useState(props.initialQuantity || "");
  const [data, setData] = useState(
    props.initialData || {
      coupon_name: "",
      coupon_code: "",
      description: "",
    },
  );

  const today = new Date();
  // Clear time portion to allow selecting today's date smoothly
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (props.initialData) {
      setData(props.initialData);
    }
  }, [props.initialData]);

  useEffect(() => {
    if (props.initialStartDate !== undefined)
      setStartDate(props.initialStartDate);
  }, [props.initialStartDate]);

  useEffect(() => {
    if (props.initialEndDate !== undefined) setEndDate(props.initialEndDate);
  }, [props.initialEndDate]);

  useEffect(() => {
    if (props.initialAvailableDate !== undefined)
      setAvailableDate(props.initialAvailableDate);
  }, [props.initialAvailableDate]);

  useEffect(() => {
    if (props.initialQuantity !== undefined) setQuantity(props.initialQuantity);
  }, [props.initialQuantity]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    if (name === "quantity") {
      setQuantity(value);
      if (value === "") {
        props.setErrorLabelquantity("Please enter total quantity!");
      } else if (Number(value) <= 0) {
        props.setErrorLabelquantity("Quantity must be greater than 0!");
      } else {
        props.setErrorLabelquantity("");
      }
      return;
    }

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "coupon_name") {
      props.setErrorLabelname(value === "" ? "Please enter coupon name!" : "");
    } else if (name === "coupon_code") {
      if (value === "") {
        props.setErrorLabelcode("Please enter coupon code!");
      } else if (!alphanumericRegex.test(value)) {
        props.setErrorLabelcode("Please enter alphanumeric characters only!");
      } else {
        props.setErrorLabelcode("");
      }
    }
  };

  const handleStart = (e) => {
    setStartDate(e);
    props.setErrorLabelstart("");
  };

  const handleEnd = (e) => {
    setEndDate(e);
    props.setErrorLabelend("");
  };

  const handleAvailableDate = (e) => {
    setAvailableDate(e);
    props.setErrorLabelAvailableDate("");
  };

  useEffect(() => {
    props.func(data, startDate, endDate, availableDate, quantity);
  }, [data, startDate, endDate, availableDate, quantity]);

  return (
    <div className="input_fileds">
      <Form className="formmain mx-2 mt-2 signin-row profile-form pb-0">
        <Row>
          <Col md="12" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Coupon Name <span className="star-required">*</span>
              </Form.Label>
              <InputGroup className="edit-border">
                <Form.Control
                  name="coupon_name"
                  type="text"
                  placeholder="Coupon Name"
                  className="custom-formcontrol"
                  maxLength={200}
                  value={data.coupon_name || ""}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </InputGroup>
              <ErrorLabel ErrorDisplay={props.errorLabelname} />
            </Form.Group>
          </Col>

          {/* Image Upload Section */}
          {/* <div className="d-flex gap-30 mb-3 img_sec_product">
            <div className="col-4 px-0 mb-2">
              <ImageUploadCrop
                imgType="logo_img"
                aspect={1 / 1}
                recommendedSize="1000px x 1000px"
                label="Coupon"
                croppedImage={props.logoImage}
                setCroppedImage={props.setLogoImage}
              />
              <ErrorLabel ErrorDisplay={props.errorLogoImage} />
            </div>
            <div className="col-8 social-img-container">
              <ImageUploadCrop
                imgType="fb_img"
                aspect={1.91 / 1}
                recommendedSize="1200px x 630px"
                label="Social Share"
                croppedImage={props.fbImage}
                setCroppedImage={props.setFbImage}
              />
            </div>
          </div> */}
          <div className="d-flex gap-30 mb-3 img_sec_product">
            <div className="col-4 px-0 mb-2">
              <ImageUploadCrop
                imgType="logo_img"
                aspect={1 / 1}
                recommendedSize="1000px x 1000px"
                label="Coupon"
                croppedImage={props.logoImage}
                setCroppedImage={props.setLogoImage} 
              />
              <ErrorLabel ErrorDisplay={props.errorLogoImage} />
            </div>
            <div className="col-8 social-img-container">
              <ImageUploadCrop
                imgType="fb_img"
                aspect={1.91 / 1}
                recommendedSize="1200px x 630px"
                label="Social Share"
                croppedImage={props.fbImage}
                setCroppedImage={props.setFbImage} 
              />
            </div>
          </div>

          <Col md="6" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom info-sec">
                Coupon Code <span className="star-required">*</span>{" "}
                <p className="info-text-space-f13">
                  &#40;Please enter alphanumeric characters only.&#41;
                </p>
              </Form.Label>
              <InputGroup className="edit-border">
                <Form.Control
                  name="coupon_code"
                  type="text"
                  placeholder="Coupon Code"
                  className="custom-formcontrol"
                  maxLength={12}
                  value={data.coupon_code || ""}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </InputGroup>
              <ErrorLabel ErrorDisplay={props.errorLabelcode} />
            </Form.Group>
          </Col>

          {/* Total Quantity Input Field */}
          <Col md={6}>
            <Form.Group>
              <Form.Label className="form-label-custom">
                Total Quantity <span className="star-required">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="quantity"
                value={quantity}
                min="1"
                onChange={handleChange}
                placeholder="Enter Total Quantity"
                className="custom-formcontrol"
              />
              <div className="coupon-error-msg">
                <ErrorLabel ErrorDisplay={props.errorLabelquantity} />
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Row className="VoucherAmountDollar">
          {/* Start Date */}
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Coupon Publish Start Date
                <span className="star-required">*</span>
              </Form.Label>
              <div>
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={startDate}
                    className="custom-formcontrol"
                    onChange={handleStart}
                    placeholderText="Start Date"
                    minDate={today}
                    maxDate={availableDate || endDate || null}
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelstart} />
              </div>
            </Form.Group>
          </Col>

          {/* Available Until Date */}
          <Col md="4" className="VouDate">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Coupon Available Until Date{" "}
                <span className="star-required">*</span>
              </Form.Label>
              <div>
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={availableDate}
                    className="custom-formcontrol"
                    onChange={handleAvailableDate}
                    placeholderText="Available Until Date"
                    minDate={startDate || today}
                    maxDate={endDate || null}
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelAvailableDate} />
              </div>
            </Form.Group>
          </Col>

          {/* Expiration Date */}
          <Col md="4" className="">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <Form.Label className="form-label-custom">
                Coupon Expiration Date <span className="star-required">*</span>
              </Form.Label>
              <div>
                <InputGroup className="edit-border">
                  <DatePicker
                    selected={endDate}
                    className="custom-formcontrol"
                    onChange={handleEnd}
                    placeholderText="Expiration Date"
                    minDate={availableDate || startDate || today}
                  />
                  <Image
                    loading="lazy"
                    src={Datepickericon}
                    className="date-picker-icon"
                  />
                </InputGroup>
                <ErrorLabel ErrorDisplay={props.errorLabelend} />
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CreateCouponInputs;
